import React, { useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

//import images
import baconLogo from "../assets/images/baconappen.png";

//import Components
import SearchOption from '../Components/Common/SearchOption';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';
import DirectMessagesDropdown from '../Components/Common/DirectMessagesDropdown';

import { changeSidebarVisibility, toggleCoreMenuOnly, changeLayoutMode } from '../slices/thunks';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

const Header = ({ headerClass, onOpenThemeCustomizer } : any) => {
    const dispatch : any = useDispatch();
    const location = useLocation();


    const selectDashboardData = createSelector(
        (state : any) => state.Layout,
        (layout) => ({
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
            coreMenuOnly: layout.coreMenuOnly,
            layoutModeType: layout.layoutModeType
        })
      );
    // Inside your component
    const { sidebarVisibilitytype, coreMenuOnly, layoutModeType } = useSelector(selectDashboardData);

    const usuarioId = useMemo(() => {
        if (typeof window === "undefined") {
            return null;
        }
        try {
            const raw = sessionStorage.getItem("authUser");
            if (!raw) {
                return null;
            }
            const parsed = JSON.parse(raw);
            const rawId = parsed?.usuario?.id ?? parsed?.user?.id ?? parsed?.id ?? null;
            const numericId = Number(rawId);
            return Number.isFinite(numericId) ? numericId : null;
        } catch {
            return null;
        }
    }, []);
    const esSuperAdmin = usuarioId === 1;
    const isControlStockRoute =
        location.pathname.startsWith("/informes/online/control-stock") ||
        location.pathname.startsWith("/informes/offline/control-stock");
    

    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement | null;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767 && humberIcon)
            humberIcon.classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    const handleOpenControlStockSync = () => {
        if (typeof window === "undefined") {
            return;
        }
        window.dispatchEvent(new Event("control-stock-open-sync-modal"));
    };

    const handleOpenControlStockAgent = () => {
        if (typeof window === "undefined") {
            return;
        }
        window.dispatchEvent(new Event("control-stock-open-agent-widget"));
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={baconLogo} alt="BaconApp" height="20" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={baconLogo} alt="BaconApp" height="22" />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src={baconLogo} alt="BaconApp" className="logo-white-filter" height="20" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={baconLogo} alt="BaconApp" className="logo-white-filter" height="22" />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>


                            <SearchOption />
                        </div>

                        <div className="d-flex align-items-center ms-auto justify-content-end topbar-actions">

                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {esSuperAdmin && (
                                <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                    onClick={() => dispatch(toggleCoreMenuOnly(!coreMenuOnly))}>
                                    <i className={coreMenuOnly ? "ri-list-check-2 fs-22" : "ri-layout-grid-fill fs-22"}></i>
                                </button>
                            )}

                            {esSuperAdmin && (
                                <button
                                    type="button"
                                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                    onClick={onOpenThemeCustomizer}
                                    title="Personalizar interfaz"
                                >
                                    <i className="ri-settings-4-line fs-22"></i>
                                </button>
                            )}

                            {isControlStockRoute && (
                                <button
                                    type="button"
                                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                    onClick={handleOpenControlStockSync}
                                    title="Sincronizar datos"
                                >
                                    <i className="ri-refresh-line fs-22"></i>
                                </button>
                            )}

                            {isControlStockRoute && (
                                <button
                                    type="button"
                                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                    onClick={handleOpenControlStockAgent}
                                    title="Agente IA"
                                >
                                    <i className="ri-robot-2-line fs-22"></i>
                                </button>
                            )}

                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={(mode) => dispatch(changeLayoutMode(mode))}
                            />

                            <DirectMessagesDropdown />

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
